// Checks the validity of the new range
export const shiftTimeFrame = (newStart, newEnd, timeFrameObj) => {
  if (
    newStart >= timeFrameObj.min &&
    newStart <= timeFrameObj.max - timeFrameObj.minRange &&
    newEnd <= timeFrameObj.max &&
    newEnd >= timeFrameObj.min + timeFrameObj.minRange
  ) {
    let newRange = newEnd - newStart;

    if (newRange < timeFrameObj.minRange) {
      let shiftAmount = timeFrameObj.minRange - newRange;

      if (newStart === timeFrameObj.start) {
        let shiftedStart = newStart - shiftAmount;
        if (shiftedStart >= timeFrameObj.min) {
          newStart = shiftedStart;
        }
      } else if (newEnd === timeFrameObj.end) {
        let shiftedEnd = newEnd + shiftAmount;
        if (shiftedEnd <= timeFrameObj.max) {
          newEnd = shiftedEnd;
        }
      }
    }

    return {
      ...timeFrameObj,
      start: newStart,
      end: newEnd,
    };
  } else {
    return timeFrameObj;
  }
};
